export default __webpack_public_path__ + "de15b49ca5050a1f1b1e6270ebb42c5c.svg";